import { useEffect, useState } from 'react';
import { mechanicsAPI } from '../../services/api';

// ═══════════════════════════════════════════════
// 岩石力学 — 共享数据类型 + 带进程缓存的加载 hook
// ═══════════════════════════════════════════════
export type MechPoint = {
  id: number;
  depth: number;
  youngs_modulus: number | null;
  poissons_ratio: number | null;
  dynamic_youngs_modulus: number | null;
  dynamic_poissons_ratio: number | null;
  ucs: number | null;
  tensile_strength: number | null;
  friction_angle: number | null;
  cohesion: number | null;
  brittleness_index: number | null;
  sigma_v: number | null;
  sigma_h: number | null;
  sigma_h_max: number | null;
  stress_direction: number | null;
  depth_reference: 'MD' | 'TVD' | 'TVDSS' | string;
  calculation_source: string;
  calculation_basis: string;
  dynamic_calculation_source: string;
  dynamic_calculation_basis: string;
  engineering_source_dataset_id: number | null;
  dynamic_source_dataset_id: number | null;
};

const CACHE: Record<number, MechPoint[]> = {};

export function useMechProfile(projectId?: number) {
  const [data, setData] = useState<MechPoint[]>(projectId ? CACHE[projectId] ?? [] : []);
  const [loading, setLoading] = useState(!(projectId && CACHE[projectId]));

  useEffect(() => {
    if (!projectId) { setLoading(false); return; }
    if (CACHE[projectId]) setData(CACHE[projectId]);
    setLoading(true);
    mechanicsAPI.getProfile(projectId)
      .then(({ data }) => {
        const arr: MechPoint[] = Array.isArray(data) ? data : (data?.results ?? []);
        arr.sort((a, b) => a.depth - b.depth);
        CACHE[projectId] = arr;
        setData(arr);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [projectId]);

  return { data, loading };
}

export const MTH = {
  bg: '#FFFFFF', canvasBg: '#FFFFFF', grid: 'rgba(30,42,58,0.07)',
  text: '#1E2A3A', textSec: '#4F6680', textMuted: '#8598AD',
  accent: '#C2533A', accentLight: 'rgba(194,83,58,0.08)',
  headerBorder: '#D6DAE0', panelHeaderBg: '#F4F6F9',
  fontUI: '"Microsoft YaHei","PingFang SC","Hiragino Sans GB","Noto Sans SC",sans-serif',
  fontMono: '"Cascadia Code",Consolas,"SF Mono","Microsoft YaHei",monospace',
};
